import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import SharePopup from "../share_popup";
import $ from "jquery";
import ErrorLabel from "../error_label";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { actionShareDocOnMail, resetShareDocOnEmail } from './../../routes/app/auth/forms/store/index';
import { TOAST_DURATION, TOAST_POSITION, TOAST_SUCCESS_COLOR } from "../../common/app_constant";
import SharePopup from "../share_popup";

const DocumentCard = (props) => {
  const [isSharePopup, setIsSharePopup] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const { ShareDocOnMail } = useSelector(state => ({
    ...state.formStore,
  }));

  const dispatch = useDispatch();

  useEffect(() => {
    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setValue("email", userData.email);
    }
  }, []);

  useEffect(() => {
    if (ShareDocOnMail) {
      dispatch(resetShareDocOnEmail())
      if (ShareDocOnMail.status) {
        setShowEmail(false)
        if (showEmail) {
          toast.success(ShareDocOnMail.message, {
            duration: TOAST_DURATION,
            position: TOAST_POSITION,
            style: {
              color: TOAST_SUCCESS_COLOR,
            },
          });
        }
      }
    }
  }, [ShareDocOnMail]);

  const onSubmit = (data) => {
    data.policy_no = props?.policyData?.policy_no
    data.dms_ids = [props?.detailDocument?.id]
    console.log("Submitting:", data); // Add this
   
    dispatch(actionShareDocOnMail(data))
  };

  return (
    <>
     <span  onClick={(e) => {
          e.preventDefault();
              e.stopPropagation();
        }}
        >
      <div className="card">
        <div className="card-body row justify-content-between">
          <div className="col-9">
            <p className="mb-0 cursor-pointer text-primary" onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              dispatch(props.actionDownload({ dmsIds: [props?.detailDocument?.id] }));
            }}>
              {props?.detailDocument?.actual_uploaded_file_name}
            </p>
            {props.claim != true ? (
              <small>
                {moment(props?.detailDocument?.created_at).format("DD/MM/YYYY")}
              </small>
            ) : (
              <></>
            )}
          </div>
          <div className="col-3 text-center">
  <button
    type="button"
    className="btn btn-link text-primary p-0"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      setShowEmail(true);
    }}
  >
    <i className="fa fa-share me-1"></i> Share
  </button>
</div>

          <div className="col-12 mt-2">
            {showEmail ? (
              <form
                noValidate
                autoComplete="off"
               // onSubmit={handleSubmit(onSubmit)}
              >
                <div className="col-12">
                  <label className="fw-600">
                    Email
                  </label>
                  <div className="input-group mb-3">
                    <input
                      type="email"
                      className="form-control"
                      id="emailInput"
                      name="email"
                      placeholder="Enter email"
                      {...register("email", {
                        pattern: {
                          value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i,
                          message: "invalid email address",
                        },
                        required: "This field is required",
                      })}
                    />
                    <span className="input-group-text" id="basic-addon2">
                       <button 
                        type="button" 
                        className="btn"
                         onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleSubmit(onSubmit) ()
                        }}
                      
                    >
                        Send
                      </button>
                    </span>
                  </div>
                  {errors.email && (
                    <ErrorLabel message={errors?.email.message} />
                  )}
                </div>
              </form>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
      <SharePopup
        isSharePopup={isSharePopup}
      //handleShareClose={handleClosehandleClose}
      />
      </span>
    </>
    
  );
};

export default DocumentCard;
